(() => {
  let pending;
  const activate = script => new Promise(resolve => {
    const replacement = document.createElement('script');
    for (const attribute of script.attributes) {
      if (attribute.name !== 'type' && attribute.name !== 'data-src' && attribute.name !== 'src') {
        replacement.setAttribute(attribute.name, attribute.value);
      }
    }
    replacement.type = script.type === 'text/javascripts' ? 'text/javascript' : script.type || 'text/javascript';
    const source = script.getAttribute('data-src') || script.getAttribute('src');
    if (source || replacement.type === 'module') {
      replacement.addEventListener('load', resolve, { once: true });
      replacement.addEventListener('error', resolve, { once: true });
    }
    if (source) {
      replacement.async = false;
      replacement.src = source;
    } else {
      replacement.textContent = script.textContent;
    }
    script.replaceWith(replacement);
    if (!source && replacement.type !== 'module') resolve();
  });
  window.loadAsync = () => {
    if (pending) return pending;
    const scripts = Array.from(document.querySelectorAll('script[data-src], script[type="text/javascripts"]'));
    pending = scripts.reduce((chain, script) => chain.then(() => activate(script)), Promise.resolve())
      .then(() => {
        document.dispatchEvent(new CustomEvent('startasyncloading'));
        document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
      });
    return pending;
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.loadAsync, { once: true });
  } else {
    window.loadAsync();
  }
})();
